(function () {
  if (window.kspProductPdfInit) return;
  window.kspProductPdfInit = true;

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-ksp-pdf-open]');
    if (openButton) {
      const modal = document.getElementById(openButton.dataset.kspPdfOpen);
      if (modal && typeof modal.showModal === 'function') {
        modal.showModal();
      }
      return;
    }

    const closeButton = event.target.closest('[data-ksp-pdf-close]');
    if (closeButton) {
      closeButton.closest('dialog')?.close?.();
      return;
    }

    if (event.target instanceof HTMLDialogElement) {
      event.target.close();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('dialog.ksp-pdf-modal[open]').forEach((modal) => modal.close());
  });
})();
